import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

export var ParseErrorCode;

(function (ParseErrorCode) {
  // Could not parse response as JSON
  ParseErrorCode[ParseErrorCode["InvalidJSON"] = 2000] = "InvalidJSON"; // Received an error response status,
  // but not error body was provided.

  ParseErrorCode[ParseErrorCode["NoErrorBody"] = 2001] = "NoErrorBody";
})(ParseErrorCode || (ParseErrorCode = {}));
/**
 * Represents an error that is thrown during decoding
 */


export var ParseError = /*#__PURE__*/function (_Error) {
  _inherits(ParseError, _Error);

  var _super = _createSuper(ParseError);

  function ParseError(message, code) {
    var _this;

    _classCallCheck(this, ParseError);

    _this = _super.call(this, message);
    _this.name = 'ParseError'; // Maintains proper stack trace for where our error was thrown (only available on V8)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), ParseError);
    }

    _this.code = code;
    return _this;
  }

  _createClass(ParseError, null, [{
    key: "InvalidJSON",
    value: function InvalidJSON() {
      return new ParseError('Could not decode response as JSON', ParseErrorCode.InvalidJSON);
    }
  }, {
    key: "UnknownError",
    value: function UnknownError() {
      return new ParseError('An unknown error occurred.', ParseErrorCode.NoErrorBody);
    }
  }]);

  return ParseError;
}( /*#__PURE__*/_wrapNativeSuper(Error));